module.exports = __webpack_public_path__ + "static/shipmates-background-ba894ae0b454290e67ab2b227d5d0076.jpg";